import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Download } from '@styled-icons/boxicons-regular';

// components
import Title from '../../../components/Title';
import Button from '../../../components/Button';
import ContractViewer from '../../../components/ContractViewer';
import { getWindowDimensions } from '../../../utils/helpers';
import { useStore } from '../../../context/appContext';
import downloadPdfContract from '../../../apis/downloadPdfContract';

// assets
import BankLogo from '../../../assets/img/BankLogo.png';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';

const ContentDiv = styled.div`
  grid-area: content;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: minmax(0, 89vw);
  grid-template-areas:
    'logo'
    'pdfs';
  grid-gap: 0.5rem;
  justify-content: stretch;
  align-items: stretch;
`;
const ImgDiv = styled.div`
  grid-area: logo;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-grow: 1;
  justify-content: space-around;
  align-items: center;
`;

const Img = styled.img`
  height: 2.5rem;
`;

const DownloadDiv = styled.div`
  display: flex;
  text-align: right;
`;

const DownloadIcon = styled(Download)`
  padding-left: 1rem;
  height: 3rem;
  cursor: pointer;
  color: ${(p) => p.theme.primary};
`;

const DownloadIconDisabled = styled(Download)`
  padding-left: 1rem;
  height: 3rem;
  color: #a0a0a0;
  cursor: not-allowed;
`;

const ContractDiv = styled.div`
  grid-area: pdfs;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: ${(p) => p.width}px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  `;

function Contract() {
  const [view, setView] = useState(true);

  const GAEventsTracker = useGAEventsTracker("Contract Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla contrato");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!view){
      GAEventsTracker("Llego hasta el final del contrato")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);
  
  const handleOnClick = () =>{
    GAEventsTracker("Boton Firmar");
    stepForward();
  };

  const { stepForward, contracts } = useStore();
  const { width, height } = getWindowDimensions();
  const calcHeight = height * 0.65;
  const calcWidth = width * 0.9;

  const handlePdfDownload = () => {
    GAEventsTracker("Boton Descargar");
    downloadPdfContract(contracts.dataUrl);
  };
  return (
    <>
      <Title grid="title">Revisá tu contrato</Title>
      <ContentDiv>
        <ImgDiv>
          <Img src={BankLogo} />
        </ImgDiv>
        <ContractDiv height={height} width={calcWidth}>
          <ContractViewer
            height={calcHeight}
            width={calcWidth}
            contracts={contracts}
            setView={setView}
          />
        </ContractDiv>
      </ContentDiv>
      <DownloadDiv >
        <Button grid="buttons" filled onClick={handleOnClick} disabled={view}>
          Firma electrónica
        </Button>
        {
          view ?
            <DownloadIconDisabled /> :
            <DownloadIcon onClick={handlePdfDownload} />
        }
      </DownloadDiv>
    </>
  );
}

export default Contract;
